import { createDateRangeFilter } from './FilterDateRange';

export const CREATE_TIME_FILTER = createDateRangeFilter({
  id: 'createTime',
  label: 'Created',
  field: 'createTime',
});

export const UPDATE_TIME_FILTER = createDateRangeFilter({
  id: 'updateTime',
  label: 'Updated',
  field: 'updateTime',
});
